/* eslint-disable prefer-const */
import React from 'react';
import { Layout, Row, Col, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { useAuthContext } from '@unicus/react-ui-kit';
import logo from 'assets/images/logo.png';
import wlogo from 'assets/images/w-logo.png';
import CurrentUserProfile from 'components/CurrentUserProfile';
import HorizontalToolbar from 'components/HorizontalToolbar';
import { MyNotifications } from 'components';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE
} from 'constants/themeSettings';
import {
  onNavStyleChange,
  toggleCollapsedSideNav
} from 'stores/settings/settingsActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QuestionCircleOutlined } from '@ant-design/icons';
import useAuth from 'core/hooks/useAuth';
import {
  ROLE_ACCOUNTANT,
  ROLE_ADMIN,
  ROLE_CLINIC_ADMINISTRATOR,
  ROLE_FINANCIAL,
  ROLE_FINANCIAL_ADMINISTRATOR,
  ROLE_OTHER_HEALTH_PROFESSIONAL,
  ROLE_PROFESSIONAL,
  ROLE_RECEPTIONIST,
  ROLE_STUDENT
} from 'constants/types';

const { Header } = Layout;

const InsideHeader = ({
  routes,
  match,
  width,
  navCollapsed,
  navStyle,
  readOnly
}) => {
  const { isAuthenticated, user } = useAuthContext();
  const { serviceProvider } = user;
  const dispatch = useDispatch();
  const history = useHistory();
  const { hasRole } = useAuth();

  const toggleClickHandle = () => {
    if (navStyle === NAV_STYLE_DRAWER) {
      dispatch(toggleCollapsedSideNav(!navCollapsed));
    } else if (navStyle === NAV_STYLE_FIXED) {
      dispatch(onNavStyleChange(NAV_STYLE_MINI_SIDEBAR));
    } else if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      dispatch(toggleCollapsedSideNav(!navCollapsed));
    } else {
      dispatch(onNavStyleChange(NAV_STYLE_FIXED));
    }
  };

  const handleClickHelp = () => {
    window.open('https://kuidare.tawk.help/', '_blank');
  };

  const handleClickSettings = () => {
    history.push('/app/settings');
  };

  return (
    <div className="gx-header-horizontal gx-inside-header-horizontal">
      <Header className="gx-header-horizontal-main">
        <div className="gx-container">
          <Row
            align="middle"
            justify={width > TAB_SIZE ? 'start' : 'space-between'}
            gutter={[1, 0]}
            className="gx-w-100 gx-flex-nowrap"
          >
            <Col lg={3}>
              <div className="gx-header-horizontal-main-flex gx-flex-nowrap">
                <div className="gx-d-block gx-d-lg-none gx-linebar gx-mr-xs-3 6e">
                  <i
                    className="gx-icon-btn icon icon-menu gx-text-white"
                    aria-hidden="true"
                    onClick={toggleClickHandle}
                  />
                </div>
                <Link
                  to="/"
                  className="gx-d-block gx-d-lg-none gx-pointer gx-mr-xs-3 gx-pt-xs-1 gx-w-logo gx-size-50"
                >
                  <img alt="" src={wlogo} />
                </Link>
                <Link
                  to="/"
                  className="gx-d-none gx-d-lg-block gx-pointer gx-mr-xs-5 gx-logo"
                >
                  <img alt="" src={logo} />
                </Link>
              </div>
            </Col>
            <Col lg={21}>
              {width > TAB_SIZE ? (
                <Row
                  align="middle"
                  justify="space-between"
                  className="gx-flex-nowrap"
                >
                  <Col>
                    <HorizontalToolbar
                      routes={routes}
                      match={match}
                      readOnly={readOnly}
                    />
                  </Col>
                  <Col>
                    {isAuthenticated ? (
                      <div className="gx-d-flex gx-align-items-center">
                        {hasRole(
                          ROLE_ADMIN,
                          ROLE_CLINIC_ADMINISTRATOR,
                          ROLE_FINANCIAL_ADMINISTRATOR,
                          ROLE_PROFESSIONAL,
                          ROLE_OTHER_HEALTH_PROFESSIONAL,
                          ROLE_STUDENT,
                          ROLE_FINANCIAL,
                          ROLE_ACCOUNTANT,
                          ROLE_RECEPTIONIST
                        ) ? (
                          <Tooltip title="Configurações">
                            <FontAwesomeIcon
                              className="icon gx-text-white gx-pointer"
                              icon="cog"
                              onClick={handleClickSettings}
                            />
                          </Tooltip>
                        ) : null}

                        {serviceProvider ? (
                          <div className="gx-ml-3 gx-mr-2">
                            <MyNotifications iconClassName="gx-fs-lg" />
                          </div>
                        ) : null}
                        <Tooltip title="Ajuda">
                          <QuestionCircleOutlined
                            className="gx-ml-2 gx-mr-2 gx-pointer gx-text-white gx-fs-lg"
                            onClick={handleClickHelp}
                          />
                        </Tooltip>

                        <CurrentUserProfile readOnly={readOnly} />
                      </div>
                    ) : null}
                  </Col>
                </Row>
              ) : isAuthenticated ? (
                <div className="gx-d-flex gx-align-items-center">
                  <FontAwesomeIcon
                    className="icon gx-text-white gx-pointer"
                    icon="cog"
                  />

                  {serviceProvider ? (
                    <div className="gx-ml-3 gx-mr-3">
                      <MyNotifications />
                    </div>
                  ) : null}
                  <QuestionCircleOutlined
                    className="gx-mr-2 gx-pointer gx-text-white gx-fs-lg"
                    onClick={handleClickHelp}
                  />
                  <CurrentUserProfile readOnly={readOnly} />
                </div>
              ) : null}
            </Col>
          </Row>
        </div>
      </Header>
    </div>
  );
};

const mapStateToProps = ({ settings }) => {
  const { themeType, navStyle, navCollapsed, width, locale } = settings;
  return { themeType, navStyle, navCollapsed, width, locale };
};

export default connect(mapStateToProps, {})(InsideHeader);
